var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8444 17.4988C14.0144 18.7388 13.1345 19.9487 11.7946 19.9687C10.4547 19.9987 10.0247 19.1787 8.50481 19.1787C6.97491 19.1787 6.50494 19.9487 5.235 19.9987C3.92509 20.0487 2.93515 18.6788 2.09521 17.4688C0.38532 14.999 -0.924593 10.4493 0.83529 7.38951C1.70523 5.86961 3.26513 4.90967 4.95502 4.87968C6.23496 4.85968 7.45488 5.74962 8.24483 5.74962C9.02478 5.74962 10.5047 4.67969 12.0546 4.83968C12.7045 4.86968 14.5244 5.09966 15.6943 6.81955C15.6043 6.87954 13.5245 8.09946 13.5445 10.6293C13.5745 13.6491 16.1943 14.659 16.2243 14.669C16.1943 14.739 15.8043 16.1089 14.8444 17.4988ZM9.13477 1.4999C9.86472 0.669955 11.0746 0.0399973 12.0746 0C12.2046 1.16992 11.7346 2.34984 11.0346 3.18979C10.3447 4.03973 9.20476 4.69969 8.08484 4.60969C7.93485 3.45977 8.49481 2.25985 9.13477 1.4999Z",
    fill: "#FFF6F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.98d778d7617a22c4f64be76e559da26a.svg";
export { ForwardRef as ReactComponent };